@use './tooltip-vars';

:host {
  @include tooltip-vars.wb-tooltip-vars;

  display: inline-flex;
  position: relative;
}

:host([variant='inline']) {
  display: inline;
}

:host .wb-tooltip__container {
  display: flex;
  flex-direction: column;
  width: 100%;
}
